import * as React from 'react';

const Label = ({ className, children, ...props }) => (
  <label className={`text-xs text-gray-600 font-bold uppercase tracking-wide ${className}`} {...props}>
    {children}
  </label>
);

export default Label;